import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';

import NewHome from './new_home/home';//新官网首页
import MOLD from './new_home/mold';   //转模页面
import DownLoad from './new_home/download';             //下载 （稳定）版本客户端
import DownLoadNewest from './new_home/download_newest';//下载 （最新）版本客户端

import Home_mobile from './home_mobile/home_mobile';
import * as serviceWorker from './serviceWorker';
import enUS from 'antd/lib/locale-provider/en_US';
import { ConfigProvider } from 'antd';
import { createBrowserHistory } from 'history';


const browserHistory = createBrowserHistory();


//+手机版官网
export default class RouterWrap extends Component {

    constructor() {
        super();
        this.state = {
            new_api: ''
        };
    }

    componentWillMount () {
        this.setState({
            new_api: process.env.REACT_APP_USE_API
        },()=>{
            if(this.state.new_api === "new"){
                // 新接口 网易2
                const sc2 = document.createElement('script');
                sc2.src = 'http://cstaticdun.126.net/load.min.js?t=201903281201';
                sc2.id = 'v2_wy';
                document.body.appendChild(sc2);
            }else{
                // cg老接口 网易1
                const sc1 = document.createElement('script');
                sc1.src = 'http://c.dun.163yun.com/js/c.js';
                sc1.id = 'v1_wy';
                document.body.appendChild(sc1);
            }
        });
    }

    render() {
        return (
            <>
                <Router history={browserHistory}>

                    <Switch>
                        {/* CG Magic官网 */}
                        <Route path="/"     component={NewHome} exact />
                        <Route path="/mold" component={MOLD}  />

                        {/* xrender用的 */}
                        <Route path="/xrender_cg"     component={NewHome}/>
                        <Route path="/xrender_mold"   component={MOLD}/>

                        {/* 划分 这种固定 url 只可以在全的页面 */}
                        <Route path="/login"    component={NewHome}  />
                        <Route path="/register" component={NewHome}  />
                        <Route path="/password" component={NewHome}  />

                        {/*  手机官网  */}
                        <Route path="/home_mobile" component={Home_mobile}  />

                        {/* 供给公司其他的产品用的2个链接 */}
                        {/* 稳定版本下载 */}
                        <Route path="/CG_stable_version_download" component={ DownLoad }  />
                        {/* 最新版本版本下载 */}
                        <Route path="/CG_newest_version_download" component={ DownLoadNewest }  />

                        {/* 人为指定,若随意输入url, 则跳转到官网首页.需要特别注意的是这个path要写在最后！ */}
                        {/**/}
                        <Route path="/**" component={NewHome}/>
                    </Switch>

                </Router>

            </>
        )
    }
}


ReactDOM.render(
    <ConfigProvider locale={enUS}>
        <RouterWrap />
    </ConfigProvider>
    ,
    document.getElementById('root')
);

serviceWorker.unregister();
